<template lang="html">
    <div>
        <div class="app">
            <div class="center-block w-xxl w-auto-xs p-y-md">
                <div class="text-center">
                    <h2 class="_700 m-b">Telemetry</h2>
                </div>
                <div class="box">
                    <div class="box-body">
                        <form v-on:submit.prevent="submit">
                            <div class="alert alert-danger" v-if="hasError">{{errorMessage}}</div>
                            <div class="md-form-group">
                                <input type="text" class="md-input" :disabled="loading" v-model="email" />
                                <label>E-Posta Adresi</label>
                            </div>
                            <div class="md-form-group">
                                <input type="password" class="md-input" :disabled="loading" v-model="password" />
                                <label>Şifre</label>
                            </div>
                            <button type="submit" :disabled="loading" class="btn primary btn-block p-x-md">
                                <span v-if="loading">Lütfen bekleyiniz...</span>
                                <span v-if="loading == false">Oturum Aç</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


try {
    var errorMessage = 'Kullanıcı adı ya da şifre hatalı.'
    localStorage.setItem('ison', 1);
    localStorage.removeItem('ison');
} catch (exc) {
    var hasError = true;
    errorMessage = 'Tarayıcınız giriş yapmak için gerekli özelliklere sahip değil.';
}

export default {
    data: function () {
        return {
            hasError: hasError,
            email: '',
            password: '',
            loading: false,
            errorMessage: errorMessage
        }
    },
    methods: {
        submit: function () {
            this.loading = true;
            var $this = this;
            $.post('/api/v1/oauth/token', {email: this.email, password: this.password})
                .done(function (data) {
                    if (data.meta.httpStatusCode == 201) {
                        $this.$app.authenticate(data.user);
                        var dashboard = $this.$app.getDefaultDashboard();
                        if (dashboard !== undefined) {
                            $this.$router.push('/dashboards/' + dashboard.className + '?id=' + dashboard.id);
                        } else {
                            $this.$router.push('/');
                        }
                    } else {
                        $this.hasError = true;
                    }
                })
                .fail(function () {
                    $this.hasError = true;
                })
                .always(function () {
                    $this.loading = false;
                });
        }
    }
}
</script>



// WEBPACK FOOTER //
// login.vue?c4fc3aac